<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import UserPresenter from '@satellite/components/elements/presenters/user/UserPresenter.vue';
import useYardTaskAssignedEvent from './useYardTaskAssignedEvent';

import type { YardTaskTimelineEvent } from './types';

interface Props {
  event: YardTaskTimelineEvent;
  timezone: string;
  locale: string;
}

const props = defineProps<Props>();

const { t } = useI18n();
const { formattedCreatedTime, user, newAssigneeId } = useYardTaskAssignedEvent(props.event, {
  timezone: props.timezone,
  locale: props.locale
});
</script>

<template>
  <div class="d-flex flex-column gap-2 align-start justify-start">
    <div class="d-flex flex-column gap-0-5 align-start justify-start">
      <span class="d-flex flex-row flex-wrap align-center justify-start gap-1">
        <user-presenter
          v-if="user"
          class="typography-body-sm-bold text--color-text-secondary"
          :user="user"
          :display-fields="['name']" />
        <span class="typography-body-sm">{{ t('global.timeline.updatedTheTask') }}</span>
        <span class="typography-body-sm-bold text-lowercase">
          {{ t('global.basicTerms.assignee') }}
        </span>
      </span>
      <span v-if="formattedCreatedTime" class="typography-caption text--color-text-tertiary">
        {{ formattedCreatedTime }}
      </span>
    </div>

    <user-presenter
      v-if="newAssigneeId"
      :user-id="newAssigneeId"
      :display-fields="['name']"
      class="typography-body-sm" />
  </div>
</template>
